// createdTablesApi.js
import axiosInstance from "./mainApi";
import store from "../store/store"; // Redux store importálása
import {
  addCreatedTables,
  addMoreCreatedTables,
  deleteCreatedTables,
  deleteMoreCreatedTables
  //updateCreatedTables,
} from "../store/actions/objectStoreFunctions";
import workApi from "./workApi";
import createdItemApi from "./createdItemApi";
const isFrontendOnly = (x) => x?.frontend === true;
function normalizeTableEntity(t) {
  if (!t) return t;

  // ha tableId létezik, akkor azt használjuk id-nek
  const normalizedId =
    t.tableId !== undefined && t.tableId !== null ? t.tableId : t.id;
  const { tableId, ...rest } = t;
  return {
    ...rest,
    id: normalizedId
  };
}

const getAllCreatedTablesApi = async () => {
  try {
    const response = await axiosInstance.get("/createdTables");
    console.log("Loading createdTables from server response: ", response);
    if (response.status === 200) {
      const normalized = response.data.map(normalizeTableEntity);
      console.log("Normalized createdTables: ", normalized);
      store.dispatch(addMoreCreatedTables(normalized));

      return normalized;
    }
    return response.data;
  } catch (error) {
    console.error("Error fetching createdTables:", error);
    throw error;
  }
};

const getAllCreatedTablesForObjectApi = async (objectId) => {
  try {
    const response = await axiosInstance.get(
      `/createdTables/object/${objectId}`
    );
    console.log(
      "Loading createdTables for object: ",
      objectId,
      " from server response: ",
      response
    );
    if (response.status === 200) {
      const normalized = response.data.map(normalizeTableEntity);
      console.log("Normalized createdTables: ", normalized);
      store.dispatch(addMoreCreatedTables(normalized));
      return normalized;
    }
    return response.data;
  } catch (error) {
    console.error("Error fetching createdTables:", error);
    throw error;
  }
};

const getAllCreatedTablesForWorkApi = async (workId) => {
  try {
    const response = await axiosInstance.get(`/createdTables/work/${workId}`);
    console.log(
      "Loading createdTables for work: ",
      workId,
      " from server response: ",
      response
    );
    if (response.status === 200) {
      const normalized = response.data.map(normalizeTableEntity);
      console.log("Normalized createdTables: ", normalized);
      store.dispatch(addMoreCreatedTables(normalized));
      return normalized;
    }
    return response.data;
  } catch (error) {
    console.error("Error fetching createdTables:", error);
    throw error;
  }
};

const generateTablesApi = async (workId) => {
  try {
    const response = await axiosInstance.post(
      `/createdTables/generate-tables/${workId}`
    );

    console.log(
      "Generating tables for work:",
      workId,
      "server response:",
      response.data
    );

    if (response.status === 200) {
      const normalized = response.data.map(normalizeTableEntity);
      console.log("Normalized createdTables: ", normalized);
      store.dispatch(addMoreCreatedTables(normalized));

      // ⚠️ await-oljuk, hogy sorrend biztos legyen
      await Promise.all([
        workApi.getAllWorksApi(),
        createdItemApi.getAllCreatedItemsForWorkApi(workId)
      ]);
      return normalized;
    }

    return response.data;
  } catch (error) {
    console.error("Error generating tables:", error);
    throw error;
  }
};

// ===== új segédek: szerepkör + work + fájlnév =====
function getCurrentUserRoleFromStore() {
  const st = store.getState?.() || {};
  return (
    st.user?.role ||
    st.currentUser?.role ||
    st.auth?.user?.role ||
    st.auth?.currentUser?.role ||
    st.loggedUser?.role ||
    st.profile?.role ||
    "user"
  );
}

function getWorkFromStore(workId) {
  const st = store.getState?.() || {};
  const works = st.works || [];
  return works.find((w) => String(w.workId) === String(workId)) || null;
}

// diakritikákat MEGTARTJUK; csak tiltott fájlkaraktereket szedünk ki, a whitespace-ből _ lesz
function sanitizeFilenameKeepUnicode(name) {
  if (!name) return "export";
  let out = String(name)
    .replace(/[<>:"/\\|?*\u0000-\u001F]/g, "")
    .trim();
  out = out.replace(/\s+/g, "_");
  return out || "export";
}

function computeTablesBaseName(workId) {
  const role = String(getCurrentUserRoleFromStore()).toLowerCase();
  const work = getWorkFromStore(workId);

  const isCompanyOrAdmin =
    role === "admin" || role === "companyadmin" || role === "companyuser";

  let who =
    (isCompanyOrAdmin
      ? work?.user?.name || work?.user?.username
      : work?.client?.name) || (isCompanyOrAdmin ? "user" : "client");

  const base = `${sanitizeFilenameKeepUnicode(who)}_${workId}_táblák`;
  return base;
}

function triggerDownload(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

// — Külön hívások: ZIP és PDF —
// a fájlnév teljesen frontenden készül a fenti szabály szerint

async function exportKorpusZip(workId, params) {
  const response = await axiosInstance.post(
    `/createdTables/export/korpus/${workId}`,
    null,
    { params, responseType: "blob" }
  );

  const base = computeTablesBaseName(workId);
  const fileName = `${base}.zip`;

  const blob = new Blob([response.data], { type: "application/zip" });
  triggerDownload(blob, fileName);
  return true;
}

async function exportPdf(workId, params) {
  const response = await axiosInstance.post(
    `/createdTables/export/pdf/${workId}`,
    null,
    { params, responseType: "blob" }
  );

  const base = computeTablesBaseName(workId);
  const fileName = `${base}.pdf`;

  const blob = new Blob([response.data], { type: "application/pdf" });
  triggerDownload(blob, fileName);
  return true;
}

const exportTablesApi = async (
  workId,
  { colorId = null, separateByColor = false } = {}
) => {
  const params = {};
  if (colorId != null) params.colorId = colorId;
  if (separateByColor) params.separateByColor = true;

  await exportKorpusZip(workId, params);
  await exportPdf(workId, params);

  return { zip: true, pdf: true };
};

// Delete a createdTables
const deleteCreatedTablesApi = (createdTablesId) => {
  return async (dispatch) => {
    try {
      await axiosInstance.delete(`/createdTables/${createdTablesId}`);
      dispatch(deleteCreatedTables(createdTablesId));
    } catch (error) {
      throw error;
    }
  };
};

// Delete a createdTables
const deleteMultipleCreatedTablesApi = (createdTablesList) => {
  return async (dispatch) => {
    try {
      console.log(createdTablesList);
      await axiosInstance.delete(`/createdTables/delete/Tables`, {
        data: createdTablesList
      });
      console.log("CreatedTables deleted successfully.");
      dispatch(deleteMoreCreatedTables(createdTablesList));
    } catch (error) {
      console.error("Error while deleting createdTables:", error);
      throw error;
    }
  };
};

const createCreatedTablesApi = (createdTablesData) => {
  return async (dispatch) => {
    try {
      console.log("creating new createdTables: ", createdTablesData);

      const response = await axiosInstance.post(
        `/createdTables`,
        createdTablesData
      );
      console.log("CreatedTables added successfully:", response);
      dispatch(addCreatedTables(response.data));
      return response.data;
    } catch (error) {
      console.error("Error while adding createdTables:", error);
      throw error;
    }
  };
};
const updateMultipleCreatedTablesApi = (tablesDataList) => {
  return async (dispatch) => {
    try {
      if (!tablesDataList || tablesDataList.length === 0) return [];

      console.group("📤 updateMultipleCreatedTablesApi");

      console.log("Payload:", tablesDataList);

      tablesDataList.forEach((t) => {
        console.log(`Table ${t.id}`, {
          trim: t.trim,
          size: t.size,
          color: t.color,
          work: t.work
        });
      });

      const response = await axiosInstance.put(
        `/createdTables/Tables`,
        tablesDataList
      );

      console.log("Response:", response.data);

      if (response.status === 200) {
        const normalized = response.data.map(normalizeTableEntity);

        console.log("Normalized response:", normalized);

        normalized.forEach((t) => {
          console.log(`Returned table ${t.id}`, {
            trim: t.trim
          });
        });

        store.dispatch(addMoreCreatedTables(normalized));
      }

      console.groupEnd();

      return response.data;
    } catch (error) {
      console.error("Error while updating createdTables:", error);
      console.groupEnd();
      throw error;
    }
  };
};

const createMultipleCreatedTablesApi = (createdTablesDataList) => {
  return async (dispatch) => {
    try {
      const filtered = createdTablesDataList.filter((t) => !isFrontendOnly(t));
      if (filtered.length === 0) return [];
      console.log("Creating multiple createdTables");
      const response = await axiosInstance.post(
        `/createdTables/Tables`,
        filtered
      );
      console.log("CreatedTables added successfully:", response);

      // Assuming the response.data is an array of newly created Tables
      if (response.status === 200) {
        const normalized = response.data.map(normalizeTableEntity);
        store.dispatch(addMoreCreatedTables(normalized));
      }

      return response.data;
    } catch (error) {
      console.error("Error while adding createdTables:", error);
      throw error;
    }
  };
};

const getCreatedTablesOfUserAdminApi = (createdTablesId) => {
  return async (dispatch) => {
    // A függvény visszatérési értéke egy aszinkron függvény
    try {
      const response = await axiosInstance.get(
        `/createdTables/${createdTablesId}`
      );
      //   dispatch(getCreatedTablesuccess(response.data)); // API válasz feldolgozása és diszpácselése a store-ba
      return response.data;
    } catch (error) {
      console.error("Error fetching createdTables:", error);
      throw error;
    }
  };
};

export default {
  getAllCreatedTablesApi,
  getAllCreatedTablesForObjectApi,
  createMultipleCreatedTablesApi,
  getAllCreatedTablesForWorkApi,
  deleteCreatedTablesApi,
  deleteMultipleCreatedTablesApi,
  //  updateCreatedTablesApi,
  updateMultipleCreatedTablesApi,
  generateTablesApi,
  createCreatedTablesApi,
  getCreatedTablesOfUserAdminApi,
  exportTablesApi
};
